<template>
  <div class="pb50">
    <el-form size="small" ref="form" :model="form" label-width="100px">
      <el-form-item label="开启授信支付" prop="is_open"><el-switch v-model="form.is_open"></el-switch></el-form-item>
      <el-form-item label="前端顶部底图">
        <div v-if="form.background" class="default-image-box" @click="openBackground">
          <div class="image-box">
            <img :src="form.background" alt="background">
            <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg" >
              <i class="el-icon-close"></i>
            </a>
          </div>
        </div>
        <div v-else>
          <div class="img-select" @click="openBackground"><i class="el-icon-plus"></i></div>
        </div>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper"><el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button></div>
    </el-form>

    <!--商品图片组件-->
    <Upload v-if="isBackground" :config="{ total: 1 }" :isupload="isBackground" @returnImgs="returnImgsFunc">上传图片</Upload>

  </div>
</template>
<script>
  import CreditApi from '@/api/credit.js';
  import Upload from "@/components/file/Upload";
  export default {
    components: {
      Upload
    },
    data() {
      return {
        form: {
          is_open: false,
          background: false,
        },
        /*是否加载完成*/
        loading: false,
        isBackground: false,
      };
    },
    created() {
      this.getData();
    },
    methods: {
      /*获取数据*/
      getData() {
        let self = this;
        CreditApi.getSetting()
          .then(data => {
            self.form = data.data.vars.values;
            if (self.form.is_open == 'true') {
              self.form.is_open = true;
            }
          })
          .catch(error => {});
      },

      /*提交*/
      onSubmit() {
        let self = this;
        let params = self.form;
        self.loading = true;
        CreditApi.saveSetting(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '恭喜你，保存成功',
                type: 'success'
              });
              self.getData();
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },

      openBackground() {
        this.isBackground = true;
      },

      /*删除商品图片*/
      deleteImg() {
        this.form.background = '';
      },

      /*上传商品图片*/
      returnImgsFunc(e) {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true;
                return false
              }
            });
          });
          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }
          console.log(e);
          this.form.background = e[0].file_path
        }
        this.isBackground = false;
      },

    }
  };
</script>

<style lang="scss" scoped>
  .tips {
    color: #ccc;
  }
  .img-select {
    position: relative;
    width: 210px;
    height: 110px;
    margin-right: 10px;
    i {
      display: flex;
      line-height: 110px;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      border: 1px dashed #dddddd;
      font-size: 30px;
      color: #409eff;
    }
  }
  .image-box {
    width: 210px;
    height: 110px;
    overflow: hidden;
    img {
      width: 210px;
      //height: 110px;
    }
  }
  .image-box:hover .delete-btn {
    display: block;
  }
  .default-image-box {
    position: relative;
    width: 210px;
    height: 110px;
  }
  .delete-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
    background: red;
    line-height: 16px;
    font-size: 16px;
    color: #ffffff;
    display: none;
  }
</style>


// WEBPACK FOOTER //
// src/views/user/credit/setting.vue